import { useTenantData } from "contexts/tenant";

export const useMixQuantity = () => {
  const tenantData = useTenantData();
  return tenantData.mix_quantity;
};
